import styled from '@emotion/styled'
import React, { forwardRef, type HTMLProps } from 'react'
import { callCenterInternationalPhoneNumber, callCenterPhoneNumber } from '@mobi/utils/phone'
import { colors } from '@mobi/component-library/Theme/Common'
import { serviceCenterEmail } from '@mobi/utils/email'

export const CustomerServiceCentre = ({
  prefixText,
  suffixText,
  onClickPhoneNumber,
}: {
  prefixText?: string
  suffixText?: string
  onClickPhoneNumber?: () => void
}) => (
  <div>
    {prefixText ?? ''} Please contact our Customer Service Centre on{' '}
    <CustomerServiceTelephone onClick={onClickPhoneNumber} /> for more information{' '}
    {suffixText ?? ''}
  </div>
)

type Props = HTMLProps<HTMLAnchorElement> & { isInternational?: boolean }

export const CustomerServiceTelephone = forwardRef<HTMLAnchorElement, Props>(
  ({ isInternational, onClick }, ref) => {
    const { linkText, text } = isInternational
      ? { linkText: callCenterInternationalPhoneNumber, text: <>+61&nbsp;8&nbsp;9445&nbsp;5391</> }
      : { linkText: callCenterPhoneNumber, text: <>1300&nbsp;36&nbsp;36&nbsp;88</> }

    return (
      <LinkStyled href={linkText} ref={ref} onClick={onClick}>
        {text}
      </LinkStyled>
    )
  }
)

export const CustomerServiceEmail = () => (
  <LinkStyled href={`mailto:${serviceCenterEmail}`}>{serviceCenterEmail}</LinkStyled>
)

CustomerServiceTelephone.displayName = 'CustomerServiceTelephone'

const LinkStyled = styled.a({
  color: colors.studio[500],
})
